<template>
  <div class="lp-page">

    <!-- ── Hero ────────────────────────────────────────────────────────────── -->
    <header class="lp-hero">
      <svg class="lp-target-bg" viewBox="-140 -140 280 280" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <circle cx="0" cy="0" r="140" fill="rgba(255,255,255,0.06)" stroke="rgba(255,255,255,0.35)"
          stroke-width="1.2" />
        <circle cx="0" cy="0" r="124" fill="none" stroke="rgba(255,255,255,0.28)" stroke-width="1" />
        <circle cx="0" cy="0" r="82" fill="rgba(255,255,255,0.05)" stroke="rgba(255,255,255,0.35)" stroke-width="1" />
        <circle cx="0" cy="0" r="72" fill="none" stroke="rgba(255,255,255,0.28)" stroke-width="1" />
        <circle cx="0" cy="0" r="16" fill="none" stroke="rgba(255,255,255,0.6)" stroke-width="1.2" />
        <circle cx="0" cy="0" r="6" fill="none" stroke="rgba(255,255,255,0.6)" stroke-width="1.2" />
        <line x1="0" y1="-140" x2="0" y2="140" stroke="rgba(255,255,255,0.18)" stroke-width="0.8"
          transform="rotate(0)" />
        <line x1="0" y1="-140" x2="0" y2="140" stroke="rgba(255,255,255,0.18)" stroke-width="0.8"
          transform="rotate(18)" />
        <line x1="0" y1="-140" x2="0" y2="140" stroke="rgba(255,255,255,0.18)" stroke-width="0.8"
          transform="rotate(36)" />
        <line x1="0" y1="-140" x2="0" y2="140" stroke="rgba(255,255,255,0.18)" stroke-width="0.8"
          transform="rotate(54)" />
        <line x1="0" y1="-140" x2="0" y2="140" stroke="rgba(255,255,255,0.18)" stroke-width="0.8"
          transform="rotate(72)" />
        <line x1="0" y1="-140" x2="0" y2="140" stroke="rgba(255,255,255,0.18)" stroke-width="0.8"
          transform="rotate(90)" />
        <line x1="0" y1="-140" x2="0" y2="140" stroke="rgba(255,255,255,0.18)" stroke-width="0.8"
          transform="rotate(108)" />
        <line x1="0" y1="-140" x2="0" y2="140" stroke="rgba(255,255,255,0.18)" stroke-width="0.8"
          transform="rotate(126)" />
        <line x1="0" y1="-140" x2="0" y2="140" stroke="rgba(255,255,255,0.18)" stroke-width="0.8"
          transform="rotate(144)" />
        <line x1="0" y1="-140" x2="0" y2="140" stroke="rgba(255,255,255,0.18)" stroke-width="0.8"
          transform="rotate(162)" />
      </svg>

      <div class="lp-hero-content">
        <img :src="dartsHubLogo" alt="DartsHub" class="lp-brand-logo" />
        <p class="lp-tagline">Licences, tournois, inscriptions : un seul compte pour toute la communauté
          fléchettes</p>
        <div class="lp-cta">
          <template v-if="authStore.isAuthenticated">
            <RouterLink to="/profile" class="lp-btn lp-btn-primary">
              <i class="fa-solid fa-user" /> Mon profil ({{ authStore.firstname }})
            </RouterLink>
            <button type="button" class="lp-btn lp-btn-ghost" @click="logout">Se déconnecter</button>
          </template>
          <template v-else>
            <RouterLink to="/login" class="lp-btn lp-btn-primary">Se connecter</RouterLink>
            <RouterLink to="/register" class="lp-btn lp-btn-ghost">Créer un compte</RouterLink>
          </template>
        </div>
      </div>
    </header>

    <!-- ── Tournois & inscriptions ──────────────────────────────────────────── -->
    <section id="tournois" class="lp-section lp-compet">
      <div class="lp-compet-head">
        <img :src="dartsHubIcon" alt="DartsHub" class="lp-compet-logo" />
        <div>
          <h2 class="lp-compet-title">Organisez vos tournois avec DartsHub</h2>
          <p class="lp-compet-lead">Le calendrier de tous les tournois de fléchettes et la gestion des inscriptions
            en ligne pour les clubs, comités et ligues.</p>
        </div>
      </div>

      <div class="lp-compet-grid">
        <div class="lp-compet-item">
          <i class="fa-solid fa-file-signature" />
          <div>
            <strong>Inscription en ligne</strong>
            <span>Vérification de licence, catégories simple et double, limites par catégorie.</span>
          </div>
        </div>
        <div class="lp-compet-item">
          <i class="fa-solid fa-credit-card" />
          <div>
            <strong>Paiement HelloAsso</strong>
            <span>L'argent arrive directement chez vous, sans commission.</span>
          </div>
        </div>
        <div class="lp-compet-item">
          <i class="fa-solid fa-clipboard-check" />
          <div>
            <strong>Pointage le jour J</strong>
            <span>Depuis un téléphone ou un ordinateur, catégorie par catégorie.</span>
          </div>
        </div>
        <div class="lp-compet-item">
          <i class="fa-solid fa-file-export" />
          <div>
            <strong>Export vers votre logiciel</strong>
            <span>Darts4Windows, DartConnect, 3K Darts ou DartUP.</span>
          </div>
        </div>
      </div>

      <p class="lp-compet-ref">
        <i class="fa-solid fa-trophy" />
        Choisi par la Ligue Sud-Est Fléchettes pour les inscriptions de la Coupe de la Ligue 2026
      </p>

      <div class="lp-compet-cta">
        <a href="https://compet.dartshub.fr/services" target="_blank" rel="noopener" class="lp-btn lp-btn-primary">
          Organiser mon tournoi <i class="fa-solid fa-arrow-right" />
        </a>
        <a href="https://compet.dartshub.fr" target="_blank" rel="noopener" class="lp-btn lp-btn-outline">
          Voir le calendrier des tournois
        </a>
      </div>
    </section>

    <!-- ── Histoire ────────────────────────────────────────────────────────── -->
    <section id="histoire" class="lp-section lp-compet">
      <div class="lp-compet-head">
        <img :src="dartsHubIcon" alt="DartsHub" class="lp-compet-logo" />
        <div>
          <h2 class="lp-compet-title">Histoire des fléchettes en France</h2>
          <p class="lp-compet-lead">Fédérations, Ligues, Comités et clubs depuis 1922 : la frise, la carte, les doyens
            et le palmarès des championnats de France. Vous étiez là avant internet ? Aidez-nous à compléter.</p>
        </div>
      </div>
      <div class="lp-compet-cta">
        <RouterLink to="/histoire" class="lp-btn lp-btn-primary">
          Découvrir l'histoire <i class="fa-solid fa-arrow-right" />
        </RouterLink>
        <RouterLink :to="{ path: '/histoire', hash: '#contribuer' }" class="lp-btn lp-btn-outline">
          Partager un document
        </RouterLink>
      </div>
    </section>

    <!-- ── Sites connectés ──────────────────────────────────────────────────── -->
    <section class="lp-section lp-section-cards">
      <h2 class="lp-section-title">Sites connectés</h2>
      <p class="lp-section-sub">Un seul compte DartsHub pour accéder à tous ces sites</p>

      <div class="lp-cards">

        <a href="https://compet.dartshub.fr" target="_blank" rel="noopener" class="lp-card">
          <img src="https://compet.dartshub.fr/banner.png" alt="Tournois DartsHub" class="lp-card-logo" />
          <div class="lp-card-body">
            <div class="lp-card-name">Tournois DartsHub</div>
            <div class="lp-card-desc">Calendrier des tournois de fléchettes et gestion des inscriptions en ligne pour
              les clubs, comités et ligues.</div>
          </div>
          <i class="fa-solid fa-arrow-up-right-from-square lp-card-arrow" />
        </a>

        <a href="https://badarts.fr" target="_blank" rel="noopener" class="lp-card">
          <img src="https://badarts.fr/banner.png" alt="Badarts" class="lp-card-logo" />
          <div class="lp-card-body">
            <div class="lp-card-name">Badarts - Montpellier Hérault Darts Club</div>
            <div class="lp-card-desc">Association de fléchettes traditionnelles à Montpellier. Tournois, entraînements
              et événements pour tous niveaux.</div>
          </div>
          <i class="fa-solid fa-arrow-up-right-from-square lp-card-arrow" />
        </a>

        <a href="https://cmerdarts.fr" target="_blank" rel="noopener" class="lp-card">
          <img src="https://cmerdarts.fr/banner.png" alt="CMER" class="lp-card-logo" />
          <div class="lp-card-body">
            <div class="lp-card-name">Comité Méridional de Fléchettes</div>
            <div class="lp-card-desc">Organisation régionale dédiée à la promotion des fléchettes dans le sud de la
              France. Tournois et classements.</div>
          </div>
          <i class="fa-solid fa-arrow-up-right-from-square lp-card-arrow" />
        </a>

        <a href="https://licence.lsef.fr" target="_blank" rel="noopener" class="lp-card">
          <img src="https://licence.lsef.fr/banner.png" alt="LSEF" class="lp-card-logo" />
          <div class="lp-card-body">
            <div class="lp-card-name">Ligue Sud-Est Fléchettes</div>
            <div class="lp-card-desc">Plateforme de gestion des licences FFD pour les clubs et comités de la Ligue
              Sud-Est Fléchettes.</div>
          </div>
          <i class="fa-solid fa-arrow-up-right-from-square lp-card-arrow" />
        </a>

      </div>
    </section>

    <!-- ── Pourquoi un compte ────────────────────────────────────────────────── -->
    <section class="lp-section lp-section-alt">
      <h2 class="lp-section-title">Pourquoi DartsHub ?</h2>
      <div class="lp-features">
        <div class="lp-feature">
          <div class="lp-feature-icon">🔑</div>
          <div class="lp-feature-title">Un seul compte</div>
          <div class="lp-feature-desc">Connectez-vous à tous les sites partenaires avec le même identifiant</div>
        </div>
        <div class="lp-feature">
          <div class="lp-feature-icon">🛡️</div>
          <div class="lp-feature-title">Connexion sécurisée</div>
          <div class="lp-feature-desc">Authentification centralisée et sécurisée pour toute la communauté</div>
        </div>
        <div class="lp-feature">
          <div class="lp-feature-icon">📋</div>
          <div class="lp-feature-title">Licence & profil</div>
          <div class="lp-feature-desc">Gérez votre profil et votre licence depuis un espace unique</div>
        </div>
      </div>
    </section>

    <!-- ── Footer ──────────────────────────────────────────────────────────── -->
    <Footer />

  </div>
</template>

<script setup lang="ts">
import Footer from '@/components/Footer.vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/useAuthStore';
import dartsHubLogo from '@/assets/dartshub-logo-blanc.png';
import dartsHubIcon from '@/assets/logo-bleu.png';

const router = useRouter();
const authStore = useAuthStore();

const logout = () => {
  authStore.logout();
  router.push('/login');
};

</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

* {
  box-sizing: border-box;
}

.lp-page {
  font-family: 'Poppins', 'Segoe UI', sans-serif;
  background: var(--bg);
  min-height: 100svh;
}

/* ── Hero ── */
.lp-hero {
  background: linear-gradient(145deg, var(--dh-header-from) 0%, var(--primary) 60%, var(--dh-header-to) 100%);
  position: relative;
  overflow: hidden;
  text-align: center;
  padding: 80px 24px 70px;
}

.lp-target-bg {
  position: absolute;
  top: 50%;
  right: -60px;
  transform: translateY(-50%);
  width: 420px;
  height: 420px;
  pointer-events: none;
  opacity: 0.5;
}

.lp-hero-content {
  position: relative;
  z-index: 1;
  max-width: 600px;
  margin: 0 auto;
}

.lp-brand-logo {
  height: clamp(4.5rem, 14vw, 8rem);
  width: auto;
  margin-bottom: 24px;
}

.lp-tagline {
  color: rgba(255, 255, 255, 0.8);
  font-size: clamp(0.9rem, 2.5vw, 1.1rem);
  font-weight: 300;
  line-height: 1.6;
  margin: 0 0 36px;
}

.lp-cta {
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
}

.lp-btn {
  padding: 13px 32px;
  border-radius: 14px;
  font-size: 0.95rem;
  font-weight: 600;
  font-family: inherit;
  text-decoration: none;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: none;
  cursor: pointer;
}

.lp-btn-primary {
  background: linear-gradient(135deg, var(--primary) 0%, var(--primary-hover) 100%);
  color: #ffffff;
  box-shadow: 0 4px 18px rgba(30, 58, 95, 0.35);
}

.lp-btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 22px rgba(30, 58, 95, 0.45);
}

.lp-btn-ghost {
  background: rgba(255, 255, 255, 0.12);
  color: #ffffff;
  border: 2px solid rgba(255, 255, 255, 0.35);
  backdrop-filter: blur(4px);
}

.lp-btn-ghost:hover {
  background: rgba(255, 255, 255, 0.22);
  transform: translateY(-2px);
}

.lp-btn-outline {
  background: transparent;
  color: var(--primary);
  border: 2px solid var(--border);
}

.lp-btn-outline:hover {
  border-color: var(--primary);
  transform: translateY(-2px);
}

/* ── Tournois & inscriptions ── */
.lp-section.lp-compet {
  max-width: 1000px;
  margin-top: 48px;
  background: var(--bg-card);
  border: 2px solid var(--primary);
  border-radius: 20px;
  padding: 32px;
  box-shadow: 0 10px 32px color-mix(in srgb, var(--primary) 14%, transparent);
}

@media (max-width: 1048px) {
  .lp-section.lp-compet {
    margin-left: 16px;
    margin-right: 16px;
  }
}

.lp-compet-head {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 28px;
}

.lp-compet-logo {
  width: 64px;
  height: 64px;
  object-fit: contain;
  flex-shrink: 0;
}

.lp-compet-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--primary);
  margin: 0 0 6px;
}

.lp-compet-lead {
  font-size: 0.92rem;
  color: var(--text-muted);
  line-height: 1.5;
  margin: 0;
}

.lp-compet-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px 24px;
  margin-bottom: 24px;
}

.lp-compet-item {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.lp-compet-item i {
  color: var(--primary);
  font-size: 1.1rem;
  width: 22px;
  margin-top: 3px;
  flex-shrink: 0;
}

.lp-compet-item strong {
  display: block;
  font-size: 0.92rem;
  color: var(--text);
}

.lp-compet-item span {
  font-size: 0.8rem;
  color: var(--text-muted);
  line-height: 1.4;
}

.lp-compet-ref {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 0 24px;
  padding: 12px 16px;
  border-radius: 12px;
  background: color-mix(in srgb, var(--primary) 8%, transparent);
  color: var(--primary);
  font-size: 0.88rem;
  font-weight: 600;
}

.lp-compet-cta {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

@media (max-width: 700px) {
  .lp-section.lp-compet {
    padding: 22px 18px;
  }

  .lp-compet-head {
    flex-direction: column;
    text-align: center;
  }

  .lp-compet-grid {
    grid-template-columns: 1fr;
  }

  .lp-compet-cta .lp-btn {
    width: 100%;
    justify-content: center;
  }
}

/* ── Sections ── */
.lp-section {
  padding: 56px 24px;
  max-width: 900px;
  margin: 0 auto;
}

.lp-section-cards {
  max-width: 1000px;
}

.lp-section-alt {
  max-width: 100%;
  background: var(--bg-card);
  padding: 56px 24px;
}

.lp-section-alt>* {
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
}

.lp-section-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--primary);
  text-align: center;
  margin: 0 0 8px;
}

.lp-section-sub {
  text-align: center;
  color: var(--text-muted);
  font-size: 0.9rem;
  margin: 0 0 36px;
}

/* ── Cards sites ── */
.lp-cards {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

@media (max-width: 700px) {
  .lp-cards {
    grid-template-columns: 1fr;
  }
}

.lp-card {
  display: flex;
  align-items: center;
  gap: 16px;
  background: var(--bg-card);
  border: 2px solid var(--border);
  border-radius: 16px;
  padding: 20px;
  text-decoration: none;
  color: var(--text);
  transition: all 0.2s;
  box-shadow: 0 2px 8px color-mix(in srgb, var(--primary) 6%, transparent);
}

.lp-card:hover {
  border-color: var(--primary);
  box-shadow: 0 6px 20px color-mix(in srgb, var(--primary) 12%, transparent);
  transform: translateY(-2px);
}

.lp-card-logo {
  width: 90px;
  height: 60px;
  object-fit: contain;
  flex-shrink: 0;
  border-radius: 8px;
  background: var(--bg-input);
  padding: 4px;
}

.lp-card-body {
  flex: 1;
}

.lp-card-name {
  font-weight: 700;
  font-size: 1rem;
  color: var(--primary);
  margin-bottom: 4px;
}

.lp-card-desc {
  font-size: 0.8rem;
  color: var(--text-muted);
  line-height: 1.4;
}

.lp-card-arrow {
  color: var(--text-muted);
  font-size: 0.8rem;
  flex-shrink: 0;
}

.lp-card:hover .lp-card-arrow {
  color: var(--primary);
}

/* ── Features ── */
.lp-features {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 24px;
  text-align: center;
}

.lp-feature {
  padding: 8px;
}

.lp-feature-icon {
  font-size: 2.2rem;
  margin-bottom: 12px;
}

.lp-feature-title {
  font-weight: 700;
  font-size: 0.95rem;
  color: var(--primary);
  margin-bottom: 6px;
}

.lp-feature-desc {
  font-size: 0.82rem;
  color: var(--text-muted);
  line-height: 1.5;
}

/* ── Footer ── */

</style>
